import { render, staticRenderFns } from "./seoFooter.vue?vue&type=template&id=bbd210ee&scoped=true&"
import script from "./seoFooter.vue?vue&type=script&lang=js&"
export * from "./seoFooter.vue?vue&type=script&lang=js&"
import style0 from "./seoFooter.vue?vue&type=style&index=0&id=bbd210ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd210ee",
  null
  
)

export default component.exports